// export enum CtrolType {
//   text = 'text',
//   num = 'num',
//   date = 'date',
//   check = 'check',
//   radio = 'radio',
//   select = 'select',
//   divider = 'divider',
//   break = 'break',
// }
export const CtrolType = {
  label: 'label',
  text: 'text',
  num: 'num',
  date: 'date',
  check: 'check',
  radio: 'radio',
  select: 'select',
  divider: 'divider',
  break: 'break',
} as const 
type CtrolType = typeof CtrolType[keyof typeof CtrolType]

export interface ICtrl {
  uuid: string,
  type: CtrolType,
}

export interface ICtrlParam extends ICtrl {
  paramName?: string,
  label?: string,
  required?: boolean,
}

export interface ICtrlListItem {
  uuid: string,
  label: string,
  value: any,
}

export interface ICtrlList extends ICtrlParam {
  items: ICtrlListItem[]
}

export enum ICtrlRadioDirection {
  horizontal,
  vertical
}

export interface ICtrlRadio extends ICtrlList {
  direction: ICtrlRadioDirection
}

export interface IParam {
  paramName: string,
  value: any
}